/* eslint-disable react/jsx-no-literals */
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';
import Icon from 'carbon-react/lib/components/icon';

import * as styles from './kpi-metric-card.scss';

// ─── Types ────────────────────────────────────────────────────────────────────
export type StatusColor = 'positive' | 'warning' | 'negative';

const STATUS_COLORS: Record<StatusColor, string> = {
  positive: '#00815D',
  warning:  '#BA8B00',
  negative: '#C7384F'
};

export interface KpiMetricCardProps {
  label: string;
  contextLabel: string;
  value: string;
  trend?: {
    direction: 'up' | 'down';
    text: string;
  };
  status: StatusColor;
}

// ─── Single card ──────────────────────────────────────────────────────────────
const KpiMetricCard = ({ label, contextLabel, value, trend, status }: KpiMetricCardProps) => {
  const arrowColor = STATUS_COLORS[status];

  return (
    <div className={styles.kpiCard}>
      <div className={styles.header}>
        <Typography fontSize="14px" fontWeight="400" lineHeight="125%" mb={0} color="rgba(0,0,0,0.55)">
          {contextLabel}
        </Typography>
        <Typography fontSize="21px" fontWeight="500" lineHeight="105%" mb={0}>
          {label}
        </Typography>
      </div>

      <hr className={styles.divider} />

      <div className={styles.valueRow}>
        <Typography fontSize="30px" fontWeight="700" lineHeight="105%" mb={0}>
          {value}
        </Typography>
        {trend && (
          <div className={styles.trendRow}>
            <Icon type={trend.direction === 'up' ? 'arrow_up' : 'arrow_down'} color={arrowColor} />
            <Typography fontSize="14px" fontWeight="400" lineHeight="125%" mb={0} color="rgba(0,0,0,0.90)">
              {trend.text}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

// ─── Row of cards ─────────────────────────────────────────────────────────────
export interface KpiMetricCardsProps {
  metrics: KpiMetricCardProps[];
}

export const KpiMetricCards = ({ metrics }: KpiMetricCardsProps) => (
  <Box display="flex" justifyContent="space-between" gap="24px">
    {metrics.map(metric => (
      <KpiMetricCard key={metric.label} {...metric} />
    ))}
  </Box>
);
